import {
  LayoutDashboard,
  Inbox,
  Users,
  CreditCard,
  Landmark,
  MessageSquare,
  Bell,
  Settings,
  Droplet,
  Coins,
  Truck,
  Container,
  Activity,
  Wrench,
  RefreshCw,
  Split,
  Plug,
  UserCog,
  PhoneCall,
  AlertOctagon,
  type LucideIcon,
} from 'lucide-react';
import type { RequestType } from '@/types/request';

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  /** Children render as a sub-tree underneath when the group is expanded. */
  children?: NavItem[];
  /** Optional badge to render on the right of the row. */
  badge?: string | number;
}

export const REQUEST_NAV: { path: string; label: string; type: RequestType; icon: LucideIcon }[] = [
  { path: 'jisomee',          label: 'Jisomee readings',     type: 'JISOMEE_METER',     icon: Activity },
  { path: 'water-tokens',     label: 'Water tokens',         type: 'WATER_TOKEN',       icon: Coins },
  { path: 'exhauster',        label: 'Exhauster',            type: 'EXHAUSTER',         icon: Truck },
  { path: 'bowser',           label: 'Bowser',               type: 'BOWSER',            icon: Droplet },
  { path: 'sludge',           label: 'Sludge purchases',     type: 'SLUDGE',            icon: Container },
  { path: 'meter-test',       label: 'Meter test',           type: 'METER_TEST',        icon: Wrench },
  { path: 'meter-replacement',label: 'Meter replacement',    type: 'METER_REPLACEMENT', icon: RefreshCw },
  { path: 'meter-separation', label: 'Meter separation',     type: 'METER_SEPARATION',  icon: Split },
  { path: 'new-connection',   label: 'New connection',       type: 'NEW_CONNECTION',    icon: Plug },
  { path: 'change-of-name',   label: 'Change of tenancy',    type: 'CHANGE_OF_NAME',    icon: UserCog },
  { path: 'change-of-contact',label: 'Change of contact',    type: 'CHANGE_OF_CONTACT', icon: PhoneCall },
  { path: 'incidents',        label: 'Incident reports',     type: 'INCIDENT_REPORT',   icon: AlertOctagon },
];

export const NAV: NavItem[] = [
  { to: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  {
    to: '/requests',
    label: 'Requests',
    icon: Inbox,
    children: [
      { to: '/requests', label: 'All requests', icon: Inbox },
      ...REQUEST_NAV.map((r) => ({
        to: `/requests/${r.path}`,
        label: r.label,
        icon: r.icon,
      })),
    ],
  },
  { to: '/customers',         label: 'Customers',          icon: Users },
  { to: '/payments',          label: 'Payments',           icon: CreditCard },
  { to: '/banks',             label: 'Banks',              icon: Landmark },
  { to: '/messages',          label: 'Messages',           icon: MessageSquare },
  { to: '/notifications-log', label: 'Notifications log',  icon: Bell },
];

export const FOOTER_NAV: NavItem[] = [
  { to: '/settings', label: 'Settings', icon: Settings },
];
